// extracted by mini-css-extract-plugin
module.exports = {"advantage":"Advantage_advantage__xkzO2","iconContainer":"Advantage_iconContainer__mwv7G"};